import React from 'react';

const Perks = () => {
    return(
        <div>
            <p className="p1"><span className="s1"><b>Perks</b></span></p>
            <p className="p2">
                {`We love working at Social Native and we think you will too! See what it's like to work at a fast-paced, venture-backed tech startup. Located in the heart of Beverly Hills, we've recently moved into our own building and aim to fill it with smart, driven, fun people, that are eager to take ownership of meaty projects and be a part of building something great.`}
            </p>
            <ul className="l1">
                <li className="p3">Competitive salary</li>
                <li className="p3">Health/dental/vision insurance</li>
                <li className="p3">Flexible work schedule</li>
                <li className="p3">Ground floor startup opportunity</li>
                <li className="p3">Company outings and events</li>
            </ul>
        </div>
    )
};

export default Perks;


// WEBPACK FOOTER //
// ./web/js/pages/jobs_pages/components/perks.js